<template>
  <el-row type="flex" justify="center" v-if="routeName === 'Payments'">
    <el-col v-if="['DRAFT', 'OPEN', 'AUDITED'].includes(params.data.status)">
      <el-button-group>
        <el-button size="small" plain disabled>
          {{ params.data.status }}
        </el-button>
        <el-button type="info" size="small" :loading="params.postingPayment && params.postingPayment === params.data.id" v-if="params.data.ach_status_message === null || params.data.ach_status_message.length === 0 "
          :disabled="!hasChangePermission"
          @click="postPayment(params.data)">
          {{ params.postingPayment && params.postingPayment === params.data.id ? '' : 'Mark as Printed' }}
        </el-button>
      </el-button-group>
      <el-tag v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'POSTED'">
      <el-button-group v-if="params.data.recon === null">
        <el-button size="small" plain disabled v-if="params.data.ach_status_message === null || params.data.ach_status_message.length === 0 ">
          PRINTED
        </el-button>
        <el-button type="danger" size="small" v-if="params.data.ach_status_message === null || params.data.ach_status_message.length === 0 "
          :loading="(params.voidingPayment && params.voidingPayment === params.data.id) || (params.loadingRelated && params.loadingRelated === params.data.id)"
          :disabled="!hasChangePermission"
          @click="clickhandleVoidDialogVisible(params.data)">
          {{ params.voidingPayment && params.voidingPayment === params.data.id ? '' : 'Void Payment' }}
        </el-button>
      </el-button-group>
      <el-tag type="info" v-else>
        CLEARED
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'CLOSED'">
      <el-tag type="info">
        {{ params.data.recon ? 'CLEARED' : params.data.status }}
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else>
      <el-tag type="info">
        {{ params.data.status }}
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
  </el-row>
  <el-row type="flex" justify="center" v-else-if="$route.name === 'Checks'">
    <el-col v-if="['DRAFT', 'OPEN', 'AUDITED'].includes(params.data.status)">
      <el-button-group>
        <el-button size="small" plain disabled>
          {{ params.data.status }}
        </el-button>
        <el-button
          type="info"
          size="small"
          :loading="params.postingCheck && params.postingCheck === params.data.id"
          :disabled="!hasChangePermission"
          @click="postCheck(params.data)">
          {{ params.postingCheck && params.postingCheck === params.data.id ? '' : 'Mark as Printed' }}
        </el-button>
      </el-button-group>
    </el-col>
    <el-col v-else-if="params.data.status === 'POSTED'">
      <el-button-group v-if="params.data.recon === null">
        <el-button size="small" plain disabled>
          PRINTED
        </el-button>
        <el-button
          type="danger"
          size="small"
          :loading="(params.voidingCheck && params.voidingCheck === params.data.id) || (loadingRelated && loadingRelated === params.data.id)"
          @click="handleVoidDialogVisible(params.data)">
          {{ params.voidingCheck && params.voidingCheck === params.data.id ? '' : 'Void Check' }}
        </el-button>
      </el-button-group>
      <el-tag type="gray" v-else>
        CLEARED
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'CLOSED'">
      <el-tag type="gray">
        {{ params.data.recon ? 'CLEARED' : params.data.status }}
      </el-tag>
    </el-col>
    <el-col v-else>
      <el-tag type="gray">
        {{ params.data.status }}
      </el-tag>
    </el-col>
  </el-row>
  <el-row v-else type="flex" justify="center">
    <el-col v-if="['OPEN', 'AUDITED'].includes(params.data.status)">
      <el-button-group>
        <el-button size="small" plain disabled>
          {{ params.data.status }}
        </el-button>
        <el-button type="info" size="small" :disabled="checkIfBtnShouldBeDisabled(params.data.id)"
          :loading="checkIfBtnShouldBeDisabled(params.data.id)" @click="handleAuditBtnClick(params.data, getTxtName)">
          {{ checkIfBtnShouldBeDisabled(params.data.id) ? '' : 'Audit' }}
        </el-button>
      </el-button-group>
      <el-tag  v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'DRAFT'">
      <el-tag type="primary">
        {{ params.data.status }}
      </el-tag>
      <el-tag v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else>
      <el-tag type="info">
        {{ params.data.status }}
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message && params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
  </el-row>
</template>
<script>
import { defineComponent } from 'vue'
import { listViewMixins } from '@/Mixins/TransactionListViews'
// ag-grid cell renderer. defineComponent (not Vue.extend) so the grid renderers don't depend on the
// @vue/compat GLOBAL_EXTEND path. ag-grid (legacy custom-component mode) sets `this.params`.
export default defineComponent({
  mixins: [listViewMixins],
  data () {
    // Snapshot route info at creation. The template/branches must NOT reactively depend on $route:
    // on navigation vue-router updates $route before ag-grid tears the grid down, which would make every
    // cell renderer re-render (flip the v-if branch) mid-unmount and crash with "vnode is null". The grid
    // is destroyed on route change anyway, so a static snapshot is correct.
    return {
      routeName: this.$route && this.$route.name,
      routePrettyName: this.$route && this.$route.meta ? this.$route.meta.prettyName : ''
    }
  },
  methods: {
    clickhandleVoidDialogVisible (data) {
      this.params.clickhandleVoidDialogVisible(data)
    },
    postPayment (data) {
      this.params.postPayment(data)
    },
    postCheck (data) {
      this.params.postCheck(data)
    }
  },
  computed: {
    getTxtName () {
      return this.routePrettyName
    },
    hasChangePermission () {
      return this.$store.getters.checkIfUserHasRequiredPermissions(['entry.view_payment', 'entry.add_payment'])
    }
  },
  watch: {
    postingPayment (val) {
      this.postingPayment = val
    },
    voidingPayment (val) {
      this.voidingPayment = val
    },
    loadingRelated (val) {
      this.loadingRelated = val
    },
    postingCheck (val) {
      this.postingCheck = val
    }
  }
})
</script>